<template>
    <div>
        <el-dialog
                :close-on-click-modal="false"
                :title="'【'+serveName+'】 留言反馈'"
                :visible.sync="show"
                width="500px" >
            <div style="width: 100%; height: 100%;" v-loading="loading">
                <div class="w100 pl20 pr20 pt20 pb20">
                    <el-form label-width="80px" :model="form" :rules="rules" ref="ruleForm" >
                        <el-form-item label="留言内容" prop="content" >
                            <el-input v-model="form.content"
                                      type="textarea"
                                      rows="10"
                                      placeholder="为利于你的留言尽快处理，请写清楚具体描述。"></el-input>
                        </el-form-item>

                        <el-form-item label="是否公开" prop="privateFlag" s>
                            <el-radio-group v-model="form.privateFlag">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>

                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="submitForm('ruleForm')" type="primary">提 交</el-button>
                <el-button @click="show = false">取 消</el-button>
            </div>

        </el-dialog>
    </div>
</template>

<script>

    import { serveLeaveMessageAddAndEdit } from '@/api/managementCenter/advices';
    export default {
        name: "addLeave",
        components: {},
        props: [],
        data() {
            return {
                show: false,
                loading: false,
                serveName:'',
                form: {
                    title: "",
                    eventLocation: "",
                    content:'',
                    serveId:"",
                    privateFlag: 1
                },
                rules: {
                    content: [
                        { required: true, message: "请输入留言内容", trigger: "blur" }
                    ],
                    privateFlag: [
                        { required: true, message: "请选择", trigger: "change" }
                    ]
                }
            };
        },
        computed: {

        },
        methods: {

            // 显示弹框
            dialogShow (id,name) {
                // 重置表单、显示弹框
                this.show = true;
                this.serveName=name;
                this.$nextTick(function(){
                    this.$refs["ruleForm"].resetFields();
                    this.form.serveId = id;

                });
            },
            serveLeaveMessageAdd(){
                this.loading = true;

                serveLeaveMessageAddAndEdit(this.form).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0) {
                        this.$message.success(  "留言成功!" );
                        this.show=false
                        this.$emit('saveSuccess')

                    }else{
                        this.$message.warning(  data.msg||"留言失败" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(  "服务器异常!" );
                })
            },

            // 确定提交
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.serveLeaveMessageAdd()
                    } else {
                        return false;
                    }
                });
            }
        },
        watch: {

        },
        filters: {}
    };
</script>

<style scoped>

</style>
